import * as React from 'react';
import { ElementLoader, MeatballMenu } from 'ui';
import { ids } from 'app/area/administration/constants';
import { CodetableItemProps } from 'app/area/codetable/list/list-items/types';
import { MergeCodeButton } from 'app/area/codetable/common/merge-code/merge-code-button';
import { canMergeCode } from 'app/area/codetable/common/merge-code/can-merge';
import { MeatballConfirmationWrapper } from 'app/area/codetable/list/shared/meatball-confirmation-wrapper';
import styles from './meatball-menu.scss';

export const CodeListMeatballMenu = (props: CodetableItemProps) => {

  const { codetableId, isHierarchy, breadcrumbs, codeItem, translation, parentId,
    codeAccessConfiguration: { canCreate, canDelete, canDuplicate, isCentralAdmin },
    metadata, fetchingItemAccess, deletingCodeItems,
    updateMergeCode, loadCodesAccess, clearCodesAccess, addLinkFactory
  } = props;

  const isVisible = codeItem.id !== 0 && canCreate;
  const hasNoAccess = !canDelete && !canCreate;

  const handleLoadCodesAccess = () => !isCentralAdmin && loadCodesAccess(codetableId, codeItem.id);
  const handleClearCodesAccess = () => !isCentralAdmin && clearCodesAccess();

  const displayMergeCode = isCentralAdmin && canDelete
    && !!updateMergeCode && canMergeCode(codetableId, metadata?.merge, codeItem?.category);

  return <>
    <div className={styles.meatballContainer}>
      {isVisible && <MeatballMenu
        id={ids.list_search_item(codeItem.id)}
        onExpandMenu={handleLoadCodesAccess}
        onCloseMenu={handleClearCodesAccess}
        className={styles.meatball}>
        {hasNoAccess
          ? <li>
            <p className={styles.labelNoAccess}>{translation.no_access_has_been_granted}</p>
          </li>
          : !!fetchingItemAccess || !!deletingCodeItems
            ? <div className={styles.loader}>
              <ElementLoader />
            </div> : <>
              {canCreate && isHierarchy && <li>
                {addLinkFactory(translation?.add_child, breadcrumbs, codeItem.id, undefined)}
              </li>}
              {canCreate && isHierarchy && <li>
                {addLinkFactory(translation?.add_sibling, breadcrumbs, parentId, undefined)}
              </li>}
              {canDuplicate && <li>
                {addLinkFactory(translation?.duplicate_code, breadcrumbs, undefined, codeItem.id)}
              </li>}

              {canDelete
                && (displayMergeCode
                  ? <li>
                    <MergeCodeButton {...props} />
                  </li>
                  : <li>
                    <MeatballConfirmationWrapper {...props} />
                  </li>)}
            </>}
      </MeatballMenu>}
    </div>
  </>;
};
